import { motion } from "framer-motion";
import { Wind, Droplets, Wrench, Container, Filter, Fence, Waves } from "lucide-react";
import { SERVICES, IMAGES } from "@/data/site";

const ICONS = { Wind, Droplets, Wrench, Container, Filter, Fence, Waves };

export default function Services() {
  return (
    <section id="services" className="border-t border-zinc-800 py-24 lg:py-32" data-testid="services-section">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="grid gap-12 lg:grid-cols-[1fr_2fr] lg:gap-16">
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.4 }}
          >
            <p className="font-mono-industrial text-xs font-semibold uppercase tracking-[0.25em] text-orange-500">
              What we do
            </p>
            <h2 className="mt-4 font-display text-4xl font-extrabold uppercase tracking-tight text-white sm:text-5xl">
              Services
            </h2>
            <p className="mt-6 max-w-md text-base leading-relaxed text-zinc-400">
              One contractor for the water and fencing jobs that keep a property running.
              If it pumps, pipes, holds or keeps stock in — we fix it and build it.
            </p>
            <div className="mt-8 hidden overflow-hidden border border-zinc-800 lg:block">
              <img
                src={IMAGES.irrigation}
                alt="Irrigation sprinklers running across a field"
                className="h-64 w-full object-cover transition-transform duration-300 hover:scale-105"
                data-testid="services-image"
              />
            </div>
          </motion.div>

          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
            {SERVICES.map((s, i) => {
              const Icon = ICONS[s.icon];
              return (
                <motion.a
                  key={s.id}
                  href="#quote"
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-60px" }}
                  transition={{ duration: 0.35, delay: i * 0.05 }}
                  className="group relative border border-zinc-800 bg-zinc-900 p-6 transition-colors duration-150 hover:border-orange-500"
                  data-testid={`service-card-${s.id}`}
                >
                  <span className="flex h-11 w-11 items-center justify-center border border-zinc-700 bg-zinc-950 text-orange-500 transition-colors duration-150 group-hover:border-orange-500">
                    <Icon className="h-5 w-5" />
                  </span>
                  <h3 className="mt-5 font-display text-xl font-bold tracking-tight text-white">
                    {s.name}
                  </h3>
                  <p className="mt-2 text-sm leading-relaxed text-zinc-400">{s.blurb}</p>
                  <span className="mt-4 inline-block font-mono-industrial text-xs font-semibold uppercase tracking-widest text-zinc-500 transition-colors duration-150 group-hover:text-orange-500">
                    Get a quote →
                  </span>
                </motion.a>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
